const daysPerMonth = {
  1: 31,
  2: 29,
  3: 31,
  4: 30,
  5: 31,
  6: 30,
  7: 31,
  8: 31,
  9: 30,
  10: 31,
  11: 30,
  12: 31,
};

const STATE = {
  QUIT: 0,
  CONTINUE: 1,
};

function handleDay(event, { days, value }) {
  const daysOutOfRange = (days === 0 || days > 31) && value.length === 2;
  if (daysOutOfRange) {
    event.preventDefault();
    return STATE.QUIT;
  }

  if (value.length === 1) {
    if (days < 10 && days > 3) {
      setTimeout(() => {
        event.target.value = `0${days}/`;
      });
      return STATE.QUIT;
    }
  }

  if (value.length === 2 && days <= 31) {
    setTimeout(() => {
      event.target.value = `${value}/`;
    });
    return STATE.QUIT;
  }

  return STATE.CONTINUE;
}

function handleMonth(event, { days, value, month }) {
  const monthOutOfRange = (month === 0 || month > 12) && value.length === 5;
  if (monthOutOfRange) {
    event.preventDefault();
    return STATE.QUIT;
  }

  if (days > daysPerMonth[month]) {
    event.preventDefault();
    return STATE.QUIT;
  }

  if (value.length === 4) {
    if (month < 10 && month > 1) {
      const daysString = `${days}`.padStart(2, '0');
      setTimeout(() => {
        event.target.value = `${daysString}/0${month}/`;
      });
      return STATE.QUIT;
    }
  }

  if (value.length === 5) {
    if (month <= 12) {
      setTimeout(() => {
        event.target.value = `${value}/`;
      });
      return STATE.QUIT;
    }
  }

  return STATE.CONTINUE;
}

function handleYear(event, { year }) {
  if (year <= 9 && year !== 2) { // first year digit must be 2
    event.preventDefault();
    return STATE.QUIT;
  }
  if (year >= 10 && year <= 99 && year !== 20) { // second year digit must be 0
    event.preventDefault();
    return STATE.QUIT;
  }
  if (year >= 100 && year <= 999 && year === 201) { // third year digit must not be 1
    event.preventDefault();
    return STATE.QUIT;
  }

  const currentYear = new Date().getFullYear();
  if (`${year}`.length === 4 && year < currentYear) {
    event.preventDefault();
    return STATE.QUIT;
  }

  return STATE.CONTINUE;
}

export default function (event) {
  const value = event.target.value + event.key;

  const days = parseInt(value.substring(0, 2), 10);
  const month = parseInt(value.substring(3, 5), 10);
  const year = parseInt(value.substring(6, 10), 10);

  const options = { days, month, year, value };

  if (handleDay(event, options) === STATE.QUIT) {
    return;
  }
  if (handleMonth(event, options) === STATE.QUIT) {
    return;
  }
  if (handleYear(event, options) === STATE.QUIT) {
    return;
  }

  if (value.length > 10) {
    event.preventDefault();
  }
}
